var _style, _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStressLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#31B50C;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#31B50C;}\r\n\t.st3{fill:#31B50C;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100.6,
    cy: 100,
    r: 90.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 100.4,
    cy: 101,
    r: 79.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.3,96.7h78.1c0,0,6.1-1,6.2,3.9c0,2.2,0,4.5,0,4.5H56.1v-3.3C56.1,101.7,55.6,95.8,62.3,96.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.3,105.1c0,0,2.4,24,25.1,30.8c2,0.8,25.9,8.4,41.9-15.4c2.3-3.8,4.9-9.5,5.2-15.4c7.3,0,9.2,0,9.2,0 s-2.4,30.9-32.3,39.8c-3.2,0.9-30.5,8.9-50.4-17.7c-1.3-2.2-5.8-8.6-7.8-22.6C65.3,105.1,65.3,105.1,65.3,105.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.9,78.5c0,0,5.4-4.6,12.4,0c2.1,1.9,4.7,3.4,8.3,0c0.1-0.1,2.8-3.9-3.8-7.9c-2.7-1.8-11.2-6.4-21.9,0 c-1.2,1.1-6,4.9-2.8,8.3C58,79.9,60.5,82.7,64.9,78.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.5,78.5c0,0,5.4-4.6,12.4,0c2.1,1.9,4.7,3.4,8.3,0c0.1-0.1,2.8-3.9-3.8-7.9c-2.7-1.8-11.2-6.4-21.9,0 c-1.2,1.1-6,4.9-2.8,8.3C118.6,79.9,121.1,82.7,125.5,78.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressLow);
export default __webpack_public_path__ + "static/media/StressLow.26df2b98c4e8da1a08f00e1baebf785b.svg";
export { ForwardRef as ReactComponent };